import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../contexts/TranslationContext';
import './notFound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <section className='notFound__section'>
        <div className='container notFound__container'>
            <h1>404</h1>
            <h2>{t('notFound.title', 'Page non trouvée')}</h2>
            <p>{t('notFound.message', "La page que vous cherchez n'existe pas ou a été déplacée.")}</p>
            <Link to="/" className='btn btn-primary'>
                {t('notFound.link', "Retour à l'accueil")}
            </Link>
        </div>
    </section>
  );
};

export default NotFound;